import { defineStore } from 'pinia'
export const useEphemeralBackendInstancesStore = defineStore('ephemeralBackendInstances', {
  state: () => ({
    availableAuthenticationMethods: {},
    eulas: {},
    eulaRefreshRequired: {},
    alreadyTriedAutoLogin: {},
    attemptingAutoLogin: {},
  }),
  persist: false,
  share: {
    enable: true,
    initialize: true,
  },
  getters: {},
})
